// extracted by mini-css-extract-plugin
module.exports = {"container":"slider_container__2Tm_d","slider":"slider_slider__1Z4te"};